import { BaseApi } from "../../utils/BaseApi";
import { CashModel, CashSessionModel } from "../models/cash/CashModel";
import { HttpMethodEnum } from "../models/HttpMethodEnum";

export class CashApi extends BaseApi {
  private static instance: CashApi;

  public static get(): CashApi {
    if (!this.instance) {
      this.instance = new CashApi();
    }
    return this.instance;
  }

  public getAllCashes = BaseApi.createEndpoint<CashModel[], null>(
    HttpMethodEnum.GET,
    "/business/cash/all"
  );

  public updateOrCreateCashes = BaseApi.createEndpoint<
    null,
    { cash: CashModel }
  >(HttpMethodEnum.POST, "/business/cash/update");

  public getCashSession = BaseApi.createEndpoint<
    CashSessionModel,
    { sessionId: string }
  >(HttpMethodEnum.GET, "/business/cash/session");

  public updateOpeningBalance = BaseApi.createEndpoint<
    null,
    { sessionId: string; openingBalance: number }
  >(HttpMethodEnum.POST, "/business/cash/session/openingBalance");

  public closeCashSession = BaseApi.createEndpoint<
    null,
    { sessionId: string; reportedClosingAmount: number }
  >(HttpMethodEnum.POST, "/business/cash/session/closeSession");
}

export const cashApi = CashApi.get();
